<div class="task-step-a" [formGroup]="formGroup">
  <h2 class="col-12" *ngIf="false">Export Data</h2>

  <div class="form-row">
    <div class="col-10">
      <div class="form-group">
        <input type="hidden" class="page-array" formArrayName="PageList" />
        <label title="The list of pages of the report you wish to send"
          i18n-title="mouseover text explaining pages|The text that shows up on mouseover of the pages label to instruct the user what it is useful for, used in task wizard configuration step@@taskWizardPageMouseoverText"
          i18n="power bi page list label at task edit form|The page label that is present before the pages inside the report input selector@@powerBiPagesInputLabelTaskEditForm">Pages</label>
        <div class="input-wrapper" *ngIf="pageList && pageList.length > 0">
          <select class="form-control" (change)="onPageChange($event)">
            <option i18n="Select a page to add|The text that show up at the page selector if the PowerBI report has not been selected yet to load the pages and therefore there are no pages to display and the form is incomplete@@reportSelectedPages"
              value="">Select a page to add</option>
            <option *ngFor="let report of pageList" [value]="report.id">{{ report.label }}</option>
          </select>
        </div>
        <div class="input-wrapper page-checkbox-group loading-wrapper" *ngIf="!pageList">
          <i class="fa fa-circle-o-notch fa-spin fa-2x"></i>
        </div>
        <div class="input-wrapper page-checkbox-group error-wrapper" *ngIf="pageList && pageList.length <= 0">
          <input
            type="text"
            class="form-control warning"
            disabled
            *ngIf="PBIReportId.touched"
            i18n-value="no accessible pages in report warning|The text that show up at the page selector if there are no accessible pages in the report to be selected and therefore the report cannot be selected@@noAccessiblePagesReportAvailableWarning"
            value="There are no accessible pages in the selected report" />
          <input
            type="text"
            class="form-control warning"
            disabled
            *ngIf="!PBIReportId.touched"
            i18n-value="waiting report selection to display pages|The text that show up at the page selector if the PowerBI report has not been selected yet to load the pages and therefore there are no pages to display and the form is incomplete@@reportMissingToShowPagesWarning"
            value="Select a report to show the pages within" />
        </div>
      </div>
    </div>
    <div class="col-2" *ngIf="pageList && pageList.length > 0">
      <button type="button" [disabled]="!isPageSelected()"
        class="btn btn-primary btn-with-left-icon view-button btn-block " (click)="onViewClick()">

        <i class="fa fa-plus"></i>
        <span
          i18n="addDataButtonLabelTaskEditForm@@addDataButtonLabelTaskEditForm">Add</span>
      </button>
    </div>
  </div>
  <div class="form-group">
    <label i18n="Page Selecteds@@pageSelecteds">Selected </label>
    <div class="input-wrapper">
      <div class="pages-wrapper" *ngIf="PageList.value.length > 0; else noObjects">
        <table class="table table-striped table-advance table-hover pages">
          <thead>
            <tr>
              <th >#</th>
              <th class="type" i18n="Object Name@@objectNameView">
                Object Data Name</th>
              <th class="actions" i18n="Actions column at the schedule list of a task@@actionsColumnLabelTaskEdit">
                Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let obj of PageList.value" [attr.data-id]="obj.reportOrder">
              <td > {{obj.reportOrder }}</td>
              <td >{{ obj.name }}</td>
              <td class="actions">
                <div class="btn btn-sm btn-danger" (click)="onDeletePageClick(obj)"><i class="fa fa-trash"></i></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #noObjects>
        <div class="missing-page-info">
          <h3
            i18n="noRegisteredDataTaskForm@@noRegisteredDataTaskForm">
            There is no data to export for this task yet.</h3>
          <p>

            <span
              i18n="addNewDataButtonExplanation@@addNewDataButtonExplanation">
              Select the page where the chart/table you want to export is and click on Add button.</span>
          </p>
          <p class="long-description"
            i18n="noRegisteredDataDescriptionTaskForm@@noRegisteredDataDescriptionTaskForm">
            And then select on the screen which item will be exported and click save.
          </p>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<app-pbi-report-view [openModal]="eventOpenmodal.asObservable()" [workspaceId]="lastSelectedWorkspaceId"
  [reportId]="lastSelectedReportId" [title]="lastSelectedPageTitle" [showFooter]="true" [showFilter]="false"
  (objectSelected) = "emitSelectObject($event)"
  [showPages]="false" [selectObject]="true"></app-pbi-report-view>
